import type { LoaderFunctionArgs } from '~/types/route-args';
import { data as routerData } from 'react-router';
import {
    GetBuildHubStageConfigDocument,
    type GetBuildHubStageConfigQuery,
    type GetBuildHubStageConfigQueryVariables,
} from 'generated/graphql';

export const BUILD_HUB_STAGE_CONFIG_API_ROUTE =
    '/remix-api/build-hub/stage-config';

/**
 * API endpoint to fetch BuildHub stage configuration
 * This is used by the CreateBuildHubModal when Apollo Client is not available
 */
export const loader = async (args: LoaderFunctionArgs) => {
    const { context } = args;

    try {
        const stageConfigResult = await context.client.query<
            GetBuildHubStageConfigQuery,
            GetBuildHubStageConfigQueryVariables
        >({
            query: GetBuildHubStageConfigDocument,
            variables: {},
        });

        const stageConfig = stageConfigResult.data?.buildHubStageConfig;

        if (!stageConfig) {
            return routerData(
                { error: 'Failed to load stage configuration' },
                { status: 500 },
            );
        }

        return stageConfig;
    } catch (error) {
        console.error('Error fetching stage config:', error);
        return routerData(
            {
                error:
                    error instanceof Error
                        ? error.message
                        : 'Unknown error occurred',
            },
            { status: 500 },
        );
    }
};
